<template>
	<div class="category-item" :class="{selected, ghost: item.id === 'ghost'}" >
		<div class="item-info" v-longpress="{handler: longClickItem, ignoreMouse: false}">
			<div class="item-name">{{ item.name }}</div>
			<div class="item-info-adv">
				<div class="item-quantity">
					<div>x{{ quantity }}</div>
					<div v-if="item.differentVariations" class="pl-5 fill-white" v-html="getIcon('iconEye')" />
				</div>
				<div class="item-price ml-5">{{ currencyStore.readableCurrencyValue(item.price) }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import AvailabilityDot from "@/console-new/components/config/menu/AvailabilityDot.vue";
import {useCurrencyStore, useLanguageStore, useSvgStore} from "@/shared/stores";
import {useMenuStore, useUserStore} from "@/console-new/stores";
import {useCounterStore} from "@/console-new/stores/counter.store";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let menuStore = useMenuStore();
		let counterStore = useCounterStore();
		let currencyStore = useCurrencyStore();
		let svgStore = useSvgStore();
		return {getString: languageStore.getString, userStore, currencyStore, menuStore, counterStore, getIcon: svgStore.get};
	},
	emits: ['longClick'],
	name: "BottomPaymentSplitItem",
	props: {
		item: {
			type: Object,
			required: true,
			validator: (list) => {
				return list.hasOwnProperty('name') && list.hasOwnProperty('price');
			}
		},
		quantity: {
			type: Number,
			required: true,
		},
		selected: {
			type: Boolean,
			default: false,
		}
	},
	methods: {
		longClickItem() {
			if(this.item.differentVariations){
				this.$emit('longClick', this.item.menu_item_id);
			}
		}
	}
}
</script>

<style scoped lang="scss">
.category-item {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 6px;
	box-shadow: 0 2px 3px var(--color-box-shadow-3);
	border-radius: 13px;
	width: 150px;
	cursor: pointer;
	@include noSelect;
	background-color: var(--color-bg);

	@media (max-width: 420px) {
		width: 125px;
	}

	&.ghost {
		background-color: transparent;
		box-shadow: none;
		border: 1px dashed var(--color-primary);
	}

	&.selected {
		border: 1px solid var(--color-secondary);


		&.ghost {
			border: 1px dashed var(--color-secondary);
		}
	}

	.item-info {
		display: flex;
		flex-direction: column;
		padding: 0 3px;
		width: 100%;
		justify-content: space-between;
		height: 100%;
		transition: width 0.2s $transition;
		@include noSelect();

		.item-name {
			line-height: 16px;
			font-size: 14px;
			font-weight: 500;
			margin-bottom: 5px;
			width: 100%;
			@include truncateString();
		}

		.item-info-adv {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.item-quantity {
				font-size: 14px;
				font-weight: 700;
				display: flex;
				flex-direction: row;
				align-items: center;

				.fill-white {
					fill: var(--color-txt-1);
				}
			}

			.item-price {
				text-align: right;
				font-size: 13px;
				line-height: 15px;
				color: var(--color-txt-1);
				padding-right: 4px;
			}
		}
	}

}
</style>